import React from 'react';
import {
  Form,
  Button,
  Row,
  Col,
} from 'react-bootstrap';
import { Formik, FormikHelpers } from 'formik';
import { Video } from '../../types/Video';
import AdminVideoPreview from '../video/AdminVideoPreview';

interface VideoFormProps {
  initialValues: Video;
  onSave: (video: Video) => void;
  onCancel: () => void;
}

export default function VideoForm({ initialValues, onSave, onCancel }: VideoFormProps) {
  return (
    <Formik
      initialValues={initialValues}
      enableReinitialize
      onSubmit={(values: Video, { setSubmitting }: FormikHelpers<Video>) => {
        onSave(values);
        setSubmitting(false);
      }}
    >
      {(formik) => (
        <Form onSubmit={formik.handleSubmit}>
          {/* German Section */}
          <div className="border-bottom pb-4 mb-4">
            <h5 className="mb-3">German Version</h5>
            <Row>
              <Col md={6}>
                <Form.Group className="mb-3" controlId="title">
                  <Form.Label>Title (DE)</Form.Label>
                  <Form.Control
                    type="text"
                    {...formik.getFieldProps('title')}
                  />
                </Form.Group>
                <Form.Group controlId="videoId">
                  <Form.Label>Video ID (DE)</Form.Label>
                  <Form.Control
                    type="text"
                    {...formik.getFieldProps('videoId')}
                  />
                </Form.Group>
              </Col>
              <Col md={6} className="d-flex align-items-center justify-content-center">
                <AdminVideoPreview id={formik.values.videoId} />
              </Col>
            </Row>
          </div>

          {/* French Section */}
          <div className="border-bottom pb-4 mb-4">
            <h5 className="mb-3">French Version</h5>
            <Row>
              <Col md={6}>
                <Form.Group className="mb-3" controlId="title_fr">
                  <Form.Label>Title (FR)</Form.Label>
                  <Form.Control
                    type="text"
                    {...formik.getFieldProps('title_fr')}
                  />
                </Form.Group>
                <Form.Group controlId="videoId_fr">
                  <Form.Label>Video ID (FR)</Form.Label>
                  <Form.Control
                    type="text"
                    {...formik.getFieldProps('videoId_fr')}
                  />
                </Form.Group>
              </Col>
              <Col md={6} className="d-flex align-items-center justify-content-center">
                <AdminVideoPreview id={formik.values.videoId_fr} />
              </Col>
            </Row>
          </div>

          {/* Italian Section */}
          <div className="mb-4">
            <h5 className="mb-3">Italian Version</h5>
            <Row>
              <Col md={6}>
                <Form.Group className="mb-3" controlId="title_it">
                  <Form.Label>Title (IT)</Form.Label>
                  <Form.Control
                    type="text"
                    {...formik.getFieldProps('title_it')}
                  />
                </Form.Group>
                <Form.Group controlId="videoId_it">
                  <Form.Label>Video ID (IT)</Form.Label>
                  <Form.Control
                    type="text"
                    {...formik.getFieldProps('videoId_it')}
                  />
                </Form.Group>
              </Col>
              <Col md={6} className="d-flex align-items-center justify-content-center">
                <AdminVideoPreview id={formik.values.videoId_it} />
              </Col>
            </Row>
          </div>

          <div className="d-flex justify-content-end gap-2">
            <Button variant="secondary" onClick={onCancel}>
              Cancel
            </Button>
            <Button variant="primary" type="submit">
              Save
            </Button>
          </div>
        </Form>
      )}
    </Formik>
  );
}
